export function disableDarkMode() {
    localStorage.setItem("darkmode", "off");
    document.body.classList.remove("dark-mode");
}

export function enableDarkMode() {
    localStorage.setItem("darkmode", "on");
    document.body.classList.add("dark-mode");
}
